import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchProductContentGrid} from 'api';
import {createGridListModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {ProductContentRawRow} from 'types';

const domain = rootDomain.createDomain('AggregateContentListDomain');

export const Gate = createGate<{markingCode: string; gtin: string | null}>(
    'AggregateContentListGate',
);

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchProductContentGrid,
});

export const {
    pageNumber$,
    pageNumberChanged,
    pageIncremented,
    pageSize$,
    pageSizeChanged,
    filters$,
    filtersChanged,
    filtersSubmit,
    filtersReset,
    sortings$,
    sortingsChanged,
    sortingsReset,
    listStateChanged,
} = createGridListModel({domain, Gate});

export const data$ = domain.createStore<ProductContentRawRow[]>([]);

export const listState$ = combine({
    data: data$,
    filters: filters$,
    sortings: sortings$,
    pageIncremented,
    isLoading: fetchDataFx.pending,
});
